export default {
  path: "/arquivos",
  name: "Arquivos",
  component: () => import("../pages/index.vue")
};
